<script setup lang="ts">
import { defineProps } from 'vue';

import Button from 'primevue/button';
import Dialog from 'primevue/dialog';

import { useDeleteCalculation } from '../composables/useDeleteCalculation';

const props = defineProps<{
  calculationId: number;
}>();

const { visible, isLoading, deleteCalculation } = useDeleteCalculation(() => props.calculationId);
</script>

<template>
  <Dialog
    v-model:visible="visible"
    class="[&__.p-dialog-header]:pb-2"
    header="Czy na pewno chcesz usunąć kalkulację?"
    :style="{ width: '35rem' }"
  >
    <p class="mb-4 text-sm">
      Ta akcja jest nieodwracalna. Usunięcie kalkulacji spowoduje utratę wszystkich wprowadzonych
      danych. Czy na pewno chcesz kontynuować?
    </p>

    <div class="flex justify-center gap-4">
      <Button size="small" severity="secondary" outlined @click="visible = false"> Anuluj </Button>
      <Button size="small" :loading="isLoading" @click="deleteCalculation"> Usuń </Button>
    </div>
  </Dialog>

  <Button class="!p-2" size="small" severity="secondary" outlined @click="visible = true">
    <i class="pi pi-trash"></i>
  </Button>
</template>
